const ValidatePassword = (password) => {
    const regex = /^(?=.*[A-Z])(?=.*[!@#$%&*^\=\+\(\)|\-_=\?,.\<\>\/])(?=.*[0-9])(?=.*[a-z]).{12,}$/g;
    return regex.test(password);
}

export default ValidatePassword